<template>
  <section class="gantt_section">
    <div class="gantt_bar">
      <input type="button" value="开始" @click="start">
      <input type="button" value="暂停" @click="pause">
    </div>
    <div class="gantt_box">
      <div class="gantt_box_progress">
        <div ref="gantt" class="gantt_progress"></div>
      </div>
    </div>
  </section>
</template>

<script>
  import 'dhtmlx-gantt/codebase/sources/dhtmlxgantt'
  import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_marker'
  import '../../assets/gantt_local_cn'
  import TaskForm from "./TaskForm";
  import {
    taskMinMaxTime,
    taskActor,
  } from '../../api/api'
  import '../../assets/gantt_api'

  let range, startTime,endTime,ms, markerId, rangeTime,du;

  export default {
    name: "Gantt",
    components: {TaskForm},
    props: {
      data: null,
      scheduledId: null,
    },
    data() {
      return {
        auto: null,
        time: 0,//时间数
        n: 0,//天数
        setting: {
          view: {
            showLine: true,
            showIcon: false,
            selectedMulti: true,

          },
          check: {
            enable: true
          },
          data: {
            simpleData: {
              enable: true,
              idKey: "glid",
              pIdKey: "pglid",
              rootPId: 0
            }
          },
          callback: {
            beforeClick: function (treeId, treeNode) {
              return false;
            },
            onCheck: this.actorCheck,
          }
        },
        zNodes: [
          {id: 1, pId: 0, name: "父节点1"},
          {id: 11, pId: 1, name: "子节点1"},
          {id: 12, pId: 1, name: "子节点2"}
        ],
        taskData: [],
        taskVisible: false,
        dialogTop: '55vh',
        dialogFullScreen: false,
        loadUrl: '',
        option: 0,
        formData: null,
        actors: null,
        voidPause: false,
        voidStart: true,
      }
    },
    methods: {
      //标记线 定时移动
      start: function () {
        if (this.voidStart) {
          if (this.time >= ms) {
            this.time = 0;
            this.n = 0;
          }
          if (this.actors == null) {
            $("#voidLoad").show();
            taskActor({scheduledId: this.scheduledId}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.actors = result.data;//总构件数据
                range = this.actors.length;
                if (range > 0) {
                  SetModelVisible(this.data.id, false);
                  $("#voidLoad").hide();
                  rangeTime = ms / range;
                  this.auto = setInterval(() => {
                    this.moveMarker();
                  }, 100);
                } else {
                  this.actors = null;
                }
              }
            });
          } else {
            if (!this.voidPause) {
              SetModelVisible(this.data.id, false);
            }
            this.auto = setInterval(() => {
              this.moveMarker();
            }, 100);
          }
        }
      },
      //标记线 移动暂停
      pause: function () {
        if (this.time < ms) {
          this.voidPause = true;
        }
        clearInterval(this.auto);
      },
      //移动标记线
      moveMarker: function () {
        // if (this.time < range) {
        //   let actorTime = new Date(this.actors[this.time].startDate);
        //   let current = new Date(actorTime.getFullYear(), actorTime.getMonth(), actorTime.getDate());
        //   SetActorVisible(this.actors[this.time].actorId, true)
        //   gantt.getMarker(markerId).start_date = current;
        //   gantt.updateMarker(markerId);
        //   gantt.scrollTo(this.time, null);
        //   this.time++;
        // } else {
        //   clearInterval(this.auto);
        //   this.voidPause = false;
        //   let lastedTime = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate() + 1);
        //   gantt.getMarker(markerId).start_date = lastedTime;
        //   gantt.updateMarker(markerId);
        //   gantt.scrollTo(this.time + 1, null);
        // }
        let current = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), startTime.getHours(),
          startTime.getMinutes(), startTime.getSeconds(), this.time);
        if (this.time < ms) {
          SetActorVisible(this.actors[this.n].actorId, true)
          gantt.getMarker(markerId).start_date = current;
          gantt.updateMarker(markerId);
          gantt.scrollTo(this.time, null);
          this.time = this.time + rangeTime;
          this.n++;
        } else {
          clearInterval(this.auto);
          this.voidPause = false;
          let lastedTime = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate(), endTime.getHours(),
            endTime.getMinutes(), endTime.getSeconds(), endTime.getMilliseconds());
          gantt.getMarker(markerId).start_date = lastedTime;
          gantt.updateMarker(markerId);
          gantt.scrollTo(this.time + rangeTime, null);
        }
      },
      initMarker: function () {
        //添加标记线
        this.voidStart = false;
        taskMinMaxTime({
          proId: this.proId,
          comId: null,
          status: 1,
          scheduledId: this.scheduledId
        }, this.GLOBAL.header).then(result => {
          if (result.success && result.data != null) {
            startTime = new Date(result.data.minDate);
            endTime = new Date(result.data.maxDate);
            ms = endTime.getTime() - startTime.getTime();
            markerId = gantt.addMarker({
              start_date: startTime,
              css: "status_line",
            });
            this.voidStart = true;
          }
        });
        this.actors = null;
      }
    },
    mounted() {
      this.initMarker();
      let proId = this.data.proId;
      let comId = null;
      let status = 1;
      this.loadUrl = this.GLOBAL.businessServerPath + "/progress/searchtask?proId=" + proId + "&comId=" + comId + "&status=" + status + "&scheduledId=" + this.scheduledId;
      //初始化时间格式
      gantt.config.date_format = "%Y-%m-%d %H:%i";
      gantt.config.scale_height = 60;
      gantt.config.drag_progress = false;
      gantt.config.drag_links = false;
      gantt.config.drag_resize = false;
      gantt.config.details_on_dblclick = false;
      gantt.config.duration_step = 0;

      gantt.config.columns = [];

      let monthScaleTemplate = function (date) {
        let dateToStr = gantt.date.date_to_str("%Y-%M");
        return dateToStr(date);
      };
      gantt.config.scales = [
        {unit: "day", step: 1, format: "%j"},
        {unit: "month", step: 1, format: monthScaleTemplate},
        {unit: "year", step: 1, format: "%Y"},
      ];
      gantt.templates.progress_text = function (start, end, task) {
        return "<span style='text-align:left;'>" + Math.round(task.progress * 100) + "% </span>";
      };

      gantt.init(this.$refs.gantt);
      gantt.load(this.loadUrl);
    },
    destroyed() {
      gantt.clearAll();
      gantt.destructor();
      clearInterval(this.auto);
    }
  }
</script>

<style>
  @import "../../../node_modules/dhtmlx-gantt/codebase/dhtmlxgantt.css";
  .gantt_box {
    position: relative;
    height: 92.5%;
    width: 100%;
    display: table;
  }
  .gantt_box_progress {
    position: relative;
    display: table-cell;
    height: 100%;
  }
  .status_line {
    background-color: #0ca30a;
  }
  .gantt_progress {
    height: 99%;
  }
  .gantt_bar {
    position: relative;
    height: 30px;
    line-height: 30px;
    border-right: 1px solid #c9c9c9;
  }

  .gantt_section {
    position: relative;
    height: 100%;

  }

  .gantt_layout_cell ::-webkit-scrollbar { /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  .gantt_layout_cell ::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .gantt_layout_cell ::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/progress/CheckGantt.vue